/* eslint-disable camelcase */
import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

import type { CartItemAttribute } from '../braze.types';

import { normalizeAttributeValue } from './utils';

const getVariantAttribute = (lineItem: CartLineItem, name: string): string => {
  const attr = lineItem.variant.attributes?.find((attr) => attr.name === name);

  return normalizeAttributeValue(attr?.value);
};

export const mapCartLineItemToCartItem = (
  lineItem: CartLineItem
): CartItemAttribute => {
  const listPrice = lineItem.variant.prices?.regular?.value?.centAmount ?? 0;

  const finalPrice = lineItem.price?.value?.centAmount ?? listPrice;

  return {
    product_id: lineItem.variant.sku,
    product_name: lineItem.name,
    brand: lineItem.brand || '',
    category: getVariantAttribute(lineItem, 'primaryCategoryKey'),
    departamento: getVariantAttribute(lineItem, 'departmentId'),
    familia: getVariantAttribute(lineItem, 'familyId'),
    list_price: listPrice,
    final_price: finalPrice,
    discount: Math.max(listPrice - finalPrice, 0),
    image_url: lineItem.variant.images?.[0]?.url ?? '',
    quantity: lineItem.quantity
  };
};
